export default __webpack_public_path__ + "static/media/people.dfaf82c5.flac";